import { render, staticRenderFns } from "./NewAnswers.vue?vue&type=template&id=023b78ec&scoped=true&"
import script from "./NewAnswers.vue?vue&type=script&lang=ts&"
export * from "./NewAnswers.vue?vue&type=script&lang=ts&"
import style0 from "./NewAnswers.vue?vue&type=style&index=0&id=023b78ec&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023b78ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023b78ec')) {
      api.createRecord('023b78ec', component.options)
    } else {
      api.reload('023b78ec', component.options)
    }
    module.hot.accept("./NewAnswers.vue?vue&type=template&id=023b78ec&scoped=true&", function () {
      api.rerender('023b78ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/questions/newAnswers/NewAnswers.vue"
export default component.exports